t<template>
  <div class="calculator-wrapper">
    <div class="calculator">
      <CalculatorHeading :step="step"></CalculatorHeading>
      <CountImageInput
        :question="$t('airCon.question')"
        :counter.sync="airCon"
        :image="require('@/assets/' + airConImg)"
      >
      </CountImageInput>
      <one-button type="primary" class="next-btn" @click.native="next()">
        {{ $t('next') }}
      </one-button>
      <a @click="$router.push(getPrevStepUrl(step, $i18n.locale))" class="back-btn"
        >{{ $t('back') }}</a
      >
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import CountImageInput from "../../components/CountImageInput";
import CalculatorHeading from "../../components/CalculatorHeading";
import {
  getStepIndex,
  redirectToUnselectedStepIfAny,
  getPrevStepUrl,
  getNextStepUrl
} from "@/utils/steps.js";

export default {
  name: "AirCon",
  components: { CalculatorHeading, CountImageInput },
  data() {
    return {
      step: getStepIndex("air-con"),
      getPrevStepUrl: getPrevStepUrl,
      airCon: this.$store.state.data.airCon,
      airConImg: "aircon.png"
    };
  },
  watch: {
    displays: function() {
      this.updateAirCon(this.airCon);
    }
  },
  mounted() {
    redirectToUnselectedStepIfAny(
      this.step,
      this.$store.state.data,
      this.$router,
      this.$i18n.locale
    );
  },
  methods: {
    ...mapMutations(["updateAirCon"]),
    next() {
      setTimeout(() => this.$router.push(getNextStepUrl(this.step, this.$i18n.locale)), 200);
    }
  }
};
</script>

<style scoped>
.calculator {
  align-items: center;
}
</style>
